import { AbstractRewardScore, IRewardScore } from "@comunicare/comunicare-interfaces";
import { TranslateService } from "@ngx-translate/core";

export class RewardScore extends AbstractRewardScore implements IRewardScore {
  private translateService: TranslateService;
  constructor(data: IRewardScore, translateService: TranslateService) {
    super(data);
    this.translateService = translateService;
  }
  protected translate(key: string): string {
    return this.translateService.instant(key);
  }
}
